import { faArrowRight, faXmark } from '@fortawesome/pro-light-svg-icons'

import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

export type HeaderBannerProps = {
  children: React.ReactNode
  link: string
  onDismiss: () => void
  onClick: () => void
  testId?: string
}

export const HeaderBanner = ({ children, link, onClick, onDismiss, testId }: HeaderBannerProps) => {
  return (
    <div className='bg-primary-default flex w-full justify-between px-4 py-2'>
      <span className='hidden lg:block' />
      <span className='flex gap-2'>
        <span>
          <a
            className='text-primary-inverse hover:text-primary-inverse font-bold'
            data-testid={testId}
            href={link}
            onClick={onClick}
          >
            {children}
          </a>
          <FontAwesomeIcon className='text-primary-inverse ml-2 mt-1' icon={faArrowRight} />
        </span>
      </span>
      <button
        className='mt-1 flex lg:mt-0 lg:items-center lg:justify-end lg:gap-2'
        data-testid='dismiss-button'
        onClick={onDismiss}
      >
        <FontAwesomeIcon className='text-primary-inverse' icon={faXmark} />
        <label className='sr-only'>Dismiss</label>
      </button>
    </div>
  )
}
